var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-table',{ref:"moduleItemTable",attrs:{"list-item":_vm.listUser,"load-data":_vm.loadFirstSearch},on:{"scroll":_vm.scrollHanle}})
}
var staticRenderFns = []

export { render, staticRenderFns }